import { Capacitor } from "@capacitor/core";

export type TheraUiPlatform = "android-native" | "pwa" | "web";

function runningStandalonePwa() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;

  const standaloneDisplay = typeof window.matchMedia === "function"
    && window.matchMedia("(display-mode: standalone)").matches;

  const iosStandalone = Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
  const trustedWebActivity = typeof document !== "undefined"
    && document.referrer.startsWith("android-app://");

  return standaloneDisplay || iosStandalone || trustedWebActivity;
}

export function currentUiPlatform(): TheraUiPlatform {
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android") {
    return "android-native";
  }

  if (runningStandalonePwa()) return "pwa";
  return "web";
}
